import "./LamineTooth.module.css";
import Header from "@/reusable_sections/Header";
import EnhanceTheBeautyOfYourProperty from "./sections/EnhanceTheBeautyOfYourProperty";
import TrainingAndApparatus from "./sections/TrainingAndApparatus";
import Projects from "./sections/Projects";
import Footer from "@/reusable_sections/Footer";
export default function LamineToothPage() {
  return <div>
      <Header />
      <EnhanceTheBeautyOfYourProperty />
      <TrainingAndApparatus />
      <Projects />
      <Footer />
    </div>;
}